var _defs, _g, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpoPresentation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-d9c9ddc0-1c79-4274-a49a-657b5d29d14c",
    "data-name": "art",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 105 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-34f0eb07-0130-49bc-a6dd-31340c81bc82",
    x1: 48.65,
    y1: 70.85,
    x2: 56.35,
    y2: 78.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000",
    className: "stop2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    className: "stop1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-12c0616e-91c5-47f7-9816-acbede2fff4f",
    x1: 38.59,
    y1: 20.09,
    x2: 66.41,
    y2: 47.91,
    xlinkHref: "#uuid-34f0eb07-0130-49bc-a6dd-31340c81bc82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-ac6561a2-f165-46fa-a9a4-f5f734c041d8",
    x1: 34.29,
    y1: 34.21,
    x2: 70.71,
    y2: 70.62,
    xlinkHref: "#uuid-34f0eb07-0130-49bc-a6dd-31340c81bc82"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "m58.5,76h-12c-.55,0-1-.45-1-1s.45-1,1-1h5v-6h2v6h5c.55,0,1,.45,1,1s-.45,1-1,1Z",
    fill: "url(#uuid-34f0eb07-0130-49bc-a6dd-31340c81bc82)",
    strokeWidth: 0
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27.5,
    y: 30,
    width: 50,
    height: 8,
    rx: 2,
    ry: 2,
    fill: "url(#uuid-12c0616e-91c5-47f7-9816-acbede2fff4f)",
    opacity: 0.25,
    strokeWidth: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m30.5,38v28c0,1.1.9,2,2,2h40c1.1,0,2-.9,2-2v-28H30.5Zm13,18h-8c-.55,0-1-.45-1-1s.45-1,1-1h8c.55,0,1,.45,1,1s-.45,1-1,1Zm6-4h-14c-.55,0-1-.45-1-1s.45-1,1-1h14c.55,0,1,.45,1,1s-.45,1-1,1Zm21,8c0,.55-.45,1-1,1h-14c-.55,0-1-.45-1-1v-14c0-.55.45-1,1-1h14c.55,0,1,.45,1,1v14Z",
    fill: "url(#uuid-ac6561a2-f165-46fa-a9a4-f5f734c041d8)",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpoPresentation);
export default __webpack_public_path__ + "static/media/expo_presentation.cb0f0c31ac88982b3748d94bb66a13d7.svg";
export { ForwardRef as ReactComponent };